'use client';

import { User } from '@/types';
import { UserProvider } from '../contexts/user-context';
export function ClientProviders({ children, initialUser }: { children: React.ReactNode; initialUser: User | null }) {
  return <UserProvider initialUser={initialUser}>{children}</UserProvider>;
}
